import React from 'react'
import { Box, Typography, Grid, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useIntl } from 'react-intl'
import {
  TABLET_IMG,
  privateAreaGuideArray,
} from '../../constants/privateAreaNavigationGuide.constants'

export const PrivateAreaNavigationGuidePanel = () => {
  const intl = useIntl()
  const theme = useTheme()

  const openLinkHandler = (link) => {
    window.open(link)
  }

  const handlePrintList = () =>
    privateAreaGuideArray.map((item, i) => {
      return (
        <Grid
          key={i}
          size={{ lg: 4 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'space-between',
            minHeight: '15em',
          }}
        >
          <Box display="flex" flexDirection="column" mb={2}>
            <Typography style={{ fontWeight: 'bold' }} variant="h4" color="primary">
              {intl.formatMessage({ id: `pages.privateAreaNavigationGuide.${item.title}` })}
            </Typography>
            <Typography style={{ fontSize: '1.5em' }} color="primary">
              {intl.formatMessage({ id: `pages.privateAreaNavigationGuide.${item.description}` })}
            </Typography>
          </Box>
          <Box width="100%">
            <Button
              onClick={() => openLinkHandler(item.url)}
              color="primary"
              style={{ fontSize: '1.2em', padding: '0em 2em', marginBottom: '1em' }}
              variant="contained"
            >
              {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.checkGuide' })}
            </Button>
            <Box
              sx={{
                width: '90%',
                border: '2px solid',
                borderTop: '0px',
                borderRight: '0px',
                borderLeft: '0px',
                borderColor: theme.palette.primary.main,
                justifySelf: 'center',
              }}
            />
          </Box>
        </Grid>
      )
    })

  return (
    <Box
      display="flex"
      bgcolor="rgb(255,255,255)"
      flexDirection="column"
      alignItems="center"
      borderRadius="20px"
      mt={2}
      mb={2}
      style={{ padding: '4em 5em' }}
    >
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '2px solid',
          borderColor: theme.palette.primary.main,
          borderRadius: 5,
          paddingLeft: '2em',
          paddingRight: '2em',
          paddingBottom: '1em',
        }}
      >
        <Grid size={{ lg: 4 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Box>
            <Typography style={{ fontWeight: 'bold' }} variant="h3" color="primary">
              {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.headLine' })}
            </Typography>

            <Box mt={5}>
              <Typography variant="h3" color="primary">
                {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.subHeadLine' })}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid size={{ lg: 4 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Box mt={2}>
            <img src={TABLET_IMG} width="300" alt="" />
          </Box>
        </Grid>

        <Grid size={{ lg: 4 }} style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: '#ED7D30',
              color: 'rgb(255,255,255)',
              fontSize: '2em',
              textTransform: 'uppercase',
              '&:hover': {
                color: '#CCCCCC',
                backgroundColor: '#BE6326',
              },
            }}
            onClick={() =>
              openLinkHandler(
                'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf'
              )
            }
          >
            {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.completeGuide' })}
          </Button>
        </Grid>
      </Grid>
      <Box mt={4} mb={4} alignSelf="start">
        <Typography variant="h3" color="primary" style={{ fontWeight: 'bold' }}>
          {intl.formatMessage({ id: 'pages.privateAreaNavigationGuide.guidesByThemes' })}
        </Typography>
      </Box>
      <Grid spacing={5} container alignItems="flex-start">
        {handlePrintList()}
      </Grid>
    </Box>
  )
}
